// hooks
import useAuth from "../../hooks/useAuth"
// components
import Label from "../../components/Label"

export default function ScoutPlanMenuLabel() {
  const { user } = useAuth();
  const scoutPlan = user?.employee?.company?.[0]?.scout_plan || "no";

  const scoutPlanString = {
    no: "NEW",
    free: "무료 플랜",
    pro: "PRO 플랜",
    enterprise: "Enterprise",
  }

  const scoutPlanVariant = {
    no: "filled",
    free: "ghost",
    pro: "filled",
    enterprise: "filled",
  };

  const scoutPlanColor = {
    no: "info",
    free: "default",
    pro: "primary",
    enterprise: "primary",
  }

  if (!user || !scoutPlan) {
    return null;
  }

  return (
    <Label
      variant={scoutPlanVariant[scoutPlan]}
      color={scoutPlanColor[scoutPlan]}
    >
      {scoutPlanString[scoutPlan]}
    </Label>
  )
}
